module.exports = __webpack_public_path__ + "static/media/DaciaBlock-Regular.6cfdd8de.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/dacia-block/DaciaBlock-Regular.woff
// module id = 759
// module chunks = 6